export default __webpack_public_path__ + "static/media/brand_11.68dd4aa0.png";